import { render, staticRenderFns } from "./PremiumDeduct.vue?vue&type=template&id=bda8575e&scoped=true"
import script from "./PremiumDeduct.vue?vue&type=script&lang=js"
export * from "./PremiumDeduct.vue?vue&type=script&lang=js"
import style0 from "./PremiumDeduct.vue?vue&type=style&index=0&id=bda8575e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda8575e",
  null
  
)

export default component.exports